@if (field) {
	<mat-form-field class="full-width" appearance="outline">
		<mat-label [attr.for]="field?.key">{{ field?.label }}</mat-label>
		<textarea
			class="textarea-line-height textarea-min-height"
			matInput
			[name]="field?.key"
			[formControlName]="field?.key"
		></textarea>
		@if (controlContainer.control?.get(field?.key)?.hasError('required')) {
			<mat-error>Debe completar el campo {{ field?.label }}.</mat-error>
		}
		<!-- Max length error -->
		@if (controlContainer.control?.get(field?.key)?.hasError('maxlength')) {
			<mat-error>
				{{ field?.rules?.maxLength?.errorMessage }}
				{{ field?.rules?.maxLength?.value }}
			</mat-error>
		}
	</mat-form-field>
}
